import {LoadingType} from "../../../models/Loading";
import {format} from "date-fns";

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const stripGeneratedOrderAmountSuffix = (amount: string, clientName: string): string => {
    if (!amount || !clientName) return amount;

    return amount.replace(
        new RegExp(`\\s/\\s${escapeRegExp(clientName)}\\s/\\sID:\\s*\\d+\\s*$`),
        ''
    );
};

export const getCopiedOrderInitialValues = (
    order: any,
    defaultChecker: string,
    defaultContact: any,
    copiedAt: Date = new Date(),
) => {
    const copiedDate = format(copiedAt, 'dd.MM.yyyy');

    return {
    checker: order?.checker_id != null ? String(order.checker_id) : defaultChecker,
    client: order?.client?.name ?? '',
    vendor: order?.vendor?.name ?? '',
    service: String(order?.service?.id ?? order?.service_id ?? ''),
    amount: stripGeneratedOrderAmountSuffix(order?.amount ?? '', order?.client?.name ?? ''),
    meters: order?.meters ?? '',
    weight: order?.weight ?? '',
    buySum: null,
    saleSum: null,
    orderTime: copiedDate,
    loadingTime: copiedDate,
    clientContact: (order?.client_contacts ?? []).map((contact: any) => String(contact.id)),
    vendorContact: (order?.vendor_contacts ?? []).map((contact: any) => String(contact.id)),
    buyInvoice: null,
    saleInvoice: null,
    buyPaid: false,
    salePaid: false,
    website: false,
    cmr: order?.cmr === 1,
    reclamation: false,
    refNumber: order?.ref_number ?? '',
    carNumber: order?.car_number ?? '',
    terminal: order?.terminal ?? '',
    loadingInstructions: order?.loading_instructions ?? '',
    unloadingInstructions: order?.unloading_instructions ?? '',
    comment: order?.comment ?? '',
    loadings: (order?.loadings ?? []).map((loading: any) => ({
        ...loading,
        country: loading.country_id ?? '',
        contacts: loading.contacts?.length > 0 ? loading.contacts : [defaultContact],
        company: loading.company ?? '',
        address: loading.address ?? '',
        city: loading.city ?? '',
        deleted: false,
        type: LoadingType.Loading,
    })),
    unloadings: (order?.unloadings ?? []).map((unloading: any) => ({
        ...unloading,
        country: unloading.country_id ?? '',
        contacts: unloading.contacts?.length > 0 ? unloading.contacts : [defaultContact],
        company: unloading.company ?? '',
        address: unloading.address ?? '',
        city: unloading.city ?? '',
        deleted: false,
        type: LoadingType.Unloading,
    })),
    loaded: false,
    unloaded: false,
    documentsSent: order?.documents_sent === 1,
    needInvoice: order?.need_invoice === 1,
    value: order?.value ?? '',
    invoiceSent: false,
    draft: false,
    };
};
